import { forwardRef } from 'react'
import { SelectProps } from '../../../components/inputs/elements/types'
import { Box } from 'ui/primitives'
import { arrow, select } from './Select.css'

export const Select = forwardRef<HTMLSelectElement, SelectProps<string | number>>((props, ref) => {
	const { options, placeholder, ...rest } = props
	return (
		<Box position="relative" width="fullWidth" className={arrow}>
			<select {...rest} ref={ref} className={select}>
				{placeholder && <option value="">{placeholder}</option>}
				{options &&
					options.map(option => (
						<option key={option.value} value={option.value}>
							{option.label}
						</option>
					))}
			</select>
		</Box>
	)
})
